/* eslint-disable camelcase */
import axios from '@axios'
export const state = {
  contacts: [],
  currentPage: 0,
  perPage: 15,
  totalPages: 0,
  totalRecords: 0,
}

export const getters = {
  allContacts: (state) => state.contacts,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_CONTACTS: (state, data) => {
    if (!data) return false
    state.contacts = data.contacts
    state.currentPage = data.page
    state.perPage = data.perPage
    state.totalPages = data.totalPages
    state.totalRecords = data.totalRecords
  },

  UPDATE_CONTACT: (state, contact) => {
    state.contacts = state.contacts.filter((c) => c.id !== contact.id)
    state.contacts.unshift(contact)
  },
  CREATE_CONTACT: (state, contact) => {
    state.contacts.unshift(contact)
  },
  REMOVE_CONTACT: (state, deletedContact) => {
    state.contacts = state.contacts.filter(
      (contact) => contact.id !== deletedContact.id
    )
  },
}

export const actions = {
  async getContacts({ commit }, params = {}) {
    let { _commit } = params
    if (typeof _commit === 'boolean' && _commit === false)
      return axios.get('/sms/contacts', { params: params })
    await axios.get('/sms/contacts', { params: params }).then((resp) => {
      if (resp.status === 200) {
        commit('GET_CONTACTS', resp.data)
      }
    })
  },
  getContactsAxios({ commit }, params = {}) {
    return axios.get('/sms/contacts', { params: params })
  },
  async getContact({ commit }, contact) {
    return axios.get(`/sms/contacts/${contact.id}`)
  },
  async createContact({ commit }, contact) {
    await axios.post(`/sms/contacts`, contact).then((resp) => {
      if (resp.status === 201) {
        commit('CREATE_CONTACT', resp.data)
      }
    })
  },
  async updateContact({ commit }, contact) {
    await axios.put(`/sms/contacts`, contact).then((resp) => {
      if (resp.status === 200) {
        commit('UPDATE_CONTACT', resp.data)
      }
    })
  },
  async removeContact({ commit, dispatch }, contact) {
    await axios.delete(`/sms/contacts/${contact.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('REMOVE_CONTACT', contact)
      }
    })
  },
}
